"use client";
import InputOtp from "@/components/shared/InputOtp";
import AUTH from "@/redux/Auth";
import { useAppDispatch } from "@/redux/store";
import { FormikProps } from "formik";
import React, { useState, useEffect } from "react";

interface Props {
  formikProps: FormikProps<any>;
  mobile: string;
}

const Index: React.FC<Props> = ({ formikProps, mobile }) => {
  const dispatch = useAppDispatch();
  const [send, setSend] = useState(false);
  const [loadingResend, setLoadingResend] = useState(false);
  const [countdown, setCountdown] = useState<number>(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else if (countdown === 0 && !loadingResend) {
      setSend(false);
    }

    return () => clearTimeout(timer);
  }, [countdown, loadingResend]);

  const handleResend = async () => {
    setLoadingResend(true);
    setCountdown(60); // Set countdown to 60 seconds

    await dispatch(
      AUTH.thunks.doResendCode({
        data: {
          mobile,
        },
      })
    ).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        setSend(true);
      }
      setLoadingResend(false);
    });
  };

  return (
    <div>
      <p className="text-16 text-textColor font-[500] my-10">
        سيصلك رساله نصية علي الواتسأب يوجد بها 4 ارقام قم بادخالهم في هذا الحقل
        لتأكيد حسابك
      </p>
      <InputOtp FormikProps={formikProps} name="code" />
      <div className="flex gap-3 text-14 text-white my-10">
        لم أتلق الرمز{" "}
        <div className="flex flex-col gap-3">
          <span
            className={`text-primaryColor cursor-pointer ${
              countdown > 0 ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={() => {
              if (countdown === 0) handleResend();
            }}
          >
            {countdown > 0
              ? `اعادة الارسال (${Math.floor(countdown / 60)}:${String(
                  countdown % 60
                ).padStart(2, "0")})`
              : "اعادة الارسال"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Index;
